import { Pipe, PipeTransform } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../openapi';

@Pipe({
  name: 'applicationSubjectPlaceholder',
  standalone: true
})
export class ApplicationSubjectPlaceholderPipe implements PipeTransform {
  transform(application?: ApplicationAppEntityApplicationRead | null): string {
    switch (true) {
      case application?.service?.url === '/zajecie-pasa-prowadzenie-robot': {
        return 'Wpisz tu ulicę';
      }
      case application?.service?.url === '/wniosek-o-opinie-zgodnosci-podzialu-nieruchomosci-z-mpzp': {
        return 'Wpisz tu rodzaj wniosku:';
      }
      case application?.service?.url === '/decyzja-o-warunkach-zabudowy': {
        return 'Wpisz rodzaj wniosku';
      }
      default: {
        return 'Wpisz tu czego dotyczy wniosek';
      }
    }
  }
}
